<template>
  <div>
    <v-overlay v-model="loading" class="align-center justify-center">
      <v-card color="primary" dark width="300">
        <v-card-text>
          Loading...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>
    <v-form v-model="valid" ref="form" autocomplete="off">
      <v-container>
        <v-row>
          <v-col cols="12">
            <span class="screenHeading">User Replacement (MOC)</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="10">
            <v-autocomplete
              :items="communities"
              variant="underlined"
              item-value="communityAbbreviation"
              item-title="communityName"
              label="Select community"
              return-object
              clearable
              required
              :rules="selectedCommunityRules"
              v-model="selectedCommunity"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="10">
            <people-picker
              v-model="selectedUserToReplace"
              :user="selectedUserToReplace"
              label="Find user"
              includeInactiveUsers
              :confidentialOptions="userFindPeoplePickerConfidentialOptions"
              @clear="selectedUserToReplace = null"
              :rules="selectedUserToReplaceRules"
            ></people-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="10">
            <v-autocomplete
              :items="roles"
              item-value="value"
              item-title="name"
              label="In role"
              variant="underlined"
              return-object
              clearable
              required
              :rules="selectedRolesRules"
              v-model="selectedRoles"
              :placeholder="'Required'"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="10">
            <people-picker
              v-model="selectedNewUser"
              :user="selectedNewUser"
              label="Replace with"
              @clear="selectedNewUser = null"
              :rules="newUserRules"
            ></people-picker>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" sm="10">
            <v-btn
              :color="!selectedUserToReplace || !roleSelected ? '' : 'success'"
              :disabled="!selectedUserToReplace || !roleSelected"
              type="button"
              @click="
                () => {
                  skip = 0
                  showOccurrences()
                }
              "
            >
              Find user
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="8" class="ml-3" v-show="items.length >= 20">
            <v-text-field
              prepend-icon="priority_high"
              value="The maximum amount of results (20) was returned, you will have to search again after the replace."
              readonly
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="occurrencesExist">
          <v-col cols="12" sm="10">
            <v-data-table
              class="elevation-1"
              :headers="headers"
              :items="items"
              show-select
              :search="search"
              :custom-filter="customFilter"
            >
              <template v-slot:header.data-table-select="{ on, props }">
                <v-checkbox
                  color="green"  
                  class="header-checkbox"                
                  :model-value="allSelected"
                  @update:modelValue="onMultiSelectChange"
                  :indeterminate="selectedMocs.length > 0 && selectedMocs.length !== availableForSelection.length"
                ></v-checkbox>
              </template>
              <!-- <template v-slot:top>
                <v-row class="px-3">
                  <v-col cols="12">
                    <v-autocomplete
                      :items="changeCategories"
                      label="Search by change category"
                      hide-no-data
                      v-model="search"
                      hide-selected
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </template> -->
              <template v-slot:item="props">
                <tr>
                  <td>
                    <v-checkbox
                      color="green"                      
                      hide-details
                      :model-value="props.item.selected"
                      @update:modelValue="onItemCheckboxChange($event, props.item)"
                    ></v-checkbox>
                  </td>
                  <td>
                    <a :href="`/${props.item.mocId.substring(0, 3)}/moc/${props.item.mocId}`" target="_blank">{{
                      props.item.mocId
                    }}</a>
                  </td>
                  <td>{{ props.item.mocTitle }}</td>
                  <td>{{ props.item.changeCategory }}</td>
                  <td>{{ props.item.mocStatus.name }}</td>
                  <td>{{ props.item.userDisplayName }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row v-if="selectedUserToReplace && occurrencesExist">
          <v-col cols="12" sm="10">
            <v-btn
              :color="!valid || selectedMocs.length === 0 ? '' : 'success'"
              :disabled="!valid || selectedMocs.length === 0"
              type="button"
              @click="showConfirmationDialog = true"
              >Replace</v-btn
            >
            <v-btn type="button" class="ml-3" @click="showCancelDialog = true">Cancel</v-btn>
            <v-btn
              :color="items.length != 20 ? '' : 'warning'"
              class="ml-3 float-right"
              :disabled="items.length != 20"
              type="button"
              @click="
                () => {
                  skip = skip + 1
                  showOccurrences()
                }
              "
            >
              Next 20 Results &gt;
            </v-btn>
            <v-btn
              :color="skip < 1 ? '' : 'warning'"
              class="ml-3 float-right"
              :disabled="skip < 1"
              type="button"
              @click="
                () => {
                  skip = skip - 1
                  showOccurrences()
                }
              "
            >
              &lt; Previous 20 Results
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-dialog persistent v-model="showConfirmationDialog" max-width="500">
      <v-card v-if="showConfirmationDialog">
        <v-container>
          <h3>Are you sure you want to proceed with these changes ?</h3>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="red" text @click="replaceUser(items.length)">Yes</v-btn>
            <v-btn color="black" text @click="showConfirmationDialog = false">No</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="showCancelDialog" max-width="500">
      <v-card v-if="showCancelDialog">
        <v-container>
          <h3>Are you sure you want to cancel ?</h3>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="red" text @click="cancelChanges">Yes</v-btn>
            <v-btn color="black" text @click="showCancelDialog = false">No</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <toaster ref="toaster"></toaster>
  </div>
</template>

<script>
import MOCAdminService from '@/services/admin.service'
import PeoplePicker from '@/components/peoplePicker/PeoplePicker'
import Toaster from '@/components/Toaster'
import MOCService from '@/services/moc.service'
import { Roles } from '@/common'
import { multiPropertySort } from '@/common/arrayFunctions'

export default {
  components: {
    PeoplePicker,
    Toaster
  },
  data() {
    return {
      selectedCommunity: null,
      selectedUserToReplace: null,
      selectedNewUser: null,
      communities: [],
      loading: false,
      occurrences: {},
      valid: false,
      showConfirmationDialog: false,
      showCancelDialog: false,
      selectedRoles: [],
      selectedMocs: [],
      items: [],
      search: '',
      roles: multiPropertySort(
        [{ prop: 'value', direction: 1 }],
        Object.values(Roles.properties).filter((r) => r.value !== 'initiator')
      ),
      headers: [
        { title: 'Moc Id', key: 'mocId' },
        { title: 'Title', key: 'mocTitle' },
        { title: 'Change Category', key: 'changeCategory' },
        { title: 'Status', key: 'mocStatus.name' },
        { title: 'User Display Name' }
      ],
      userFindPeoplePickerConfidentialOptions: {},
      newUserRules: [(newValue) => (!newValue ? 'This field is required' : true)],
      selectedCommunityRules: [(newValue) => (!newValue ? 'This field is required' : true)],
      selectedUserToReplaceRules: [(newValue) => (!newValue ? 'This field is required' : true)],
      selectedRolesRules: [(newValue) => (!newValue ? 'This field is required' : true)],
      roleSelected: false,
      skip: 0
    }
  },
  computed: {
    changeCategories() {
      return this.items.map((m) => m.changeCategory)
    },
    newUserErrorMessages() {
      return this.selectedUserToReplace && this.selectedNewUser && this.selectedUserToReplace.id === this.selectedNewUser.id
        ? 'New user cannot be the same as current user'
        : null
    },
    occurrencesExist() {
      return Object.keys(this.occurrences).length > 0
    },
    availableForSelection() {
      var availableItems = this.items.filter((item) =>
        item.changeCategory.toLowerCase().includes((this.search || '').toLowerCase())
      )
      return availableItems
    },
    allSelected() {
      return this.selectedMocs && this.availableForSelection && this.selectedMocs.length === this.availableForSelection.length
    }
  },
  methods: {
    customFilter(value, search, item) {
      if (item.changeCategory.toLowerCase() === search.toLowerCase()) {
        return true
      }
      return false
    },
    onMultiSelectChange(value) {
      if (value) {
        this.selectedMocs = this.availableForSelection
        this.selectedMocs.forEach((m) => {
          m.selected = true
        })
      } else {
        this.selectedMocs.forEach((m) => {
          m.selected = false
        })
        this.selectedMocs = []
      }
    },
    onItemCheckboxChange(value, item) {
      item.selected = value
      if (value) {
        this.selectedMocs.push(item)
      } else {
        this.selectedMocs = this.selectedMocs.filter((s) => s.mocId !== item.mocId)
      }
    },
    getRolesMatched(item) {
      return item.found
        .map((r) => {
          if (r === 'response-relationship-approver') return 'Response Relationship (Approver)'
          if (r === 'response-relationship-fyi') return 'Response Relationship (FYI)'
          if (r === 'vp') return Roles.properties[r].name
          return Roles.properties[r] ? Roles.properties[r].name : ''
        })
        .join(', ')
    },
    occurrencesNewUserErrorMessages(user) {
      return user && user.id === this.selectedUserToReplace.id ? 'New user cannot be the same as current user' : null
    },
    cancelChanges() {
      this.selectedUserToReplace = null
      this.selectedNewUser = null
      this.occurrences = {}
      this.selectedCommunity = null
      this.showCancelDialog = false
      this.selectedRoles = []
    },
    showOccurrences() {
      this.loading = true
      this.occurrences = {}
      this.selectedMocs = []
      let selectedRole = this.selectedRoles.value ? [this.selectedRoles.value] : ''
      MOCService.findUserInActiveMocs(
        this.selectedCommunity.communityAbbreviation,
        this.selectedUserToReplace.id,
        selectedRole,
        this.skip
      )
        .then((response) => {
          if (!Object.keys(response).length) {
            this.$refs.toaster.pop('info', `User not found in MOCs ${this.selectedRoles.name ? 'with selected role' : ''}`)
            this.skip = 0
            return
          }
          this.occurrences = response
          this.items = Object.values(this.occurrences)
          this.items.forEach((i) => {
            i.selected = false
          })
          if (this.items.length === 20) {
            this.skip = this.skip
          } else {
            this.skip = 0
          }
        })
        .catch(() => {
          this.$refs.toaster.pop('error', 'An error has ocurred')
        })
        .finally(() => (this.loading = false))
    },
    replaceUser(searchItemsCount) {
      if (this.loading) return
      this.showConfirmationDialog = false
      this.loading = true
      MOCService.replaceUserInMOCs(this.selectedCommunity.communityAbbreviation, {
        findings: this.selectedMocs,
        oldUser: this.selectedUserToReplace,
        newUser: this.selectedNewUser
      })
        .then(() => {
          if (searchItemsCount === 20) {
            this.$refs.toaster.pop('success', 'Success')
            this.showOccurrences()
          } else {
            this.selectedMocs = []
            this.occurrences = {}
            this.items = []
            this.selectedRoles = []
            this.selectedCommunity = null
            this.selectedUserToReplace = null
            this.selectedNewUser = null
            this.$refs.toaster.pop('success', 'Success')
          }
        })
        .catch((err) => {
          this.$refs.toaster.pop('error', this.$t('Error_Replace_User'))
        })
        .finally(() => (this.loading = false))
    },
    getPeoplePickerInjectedProperties() {
      return {
        confidentialOptions: {
          confidentialCommunityAbbreviation: this.selectedCommunity.isConfidential
            ? this.selectedCommunity.communityAbbreviation
            : undefined
        }
      }
    }
  },
  created() {
    if (this.loading) return
    this.loading = true
    MOCAdminService.getUserCommunities()
      .then(
        (succ) =>
          (this.communities = [...succ.sort((a, b) => (a.communityName.toUpperCase() > b.communityName.toUpperCase() ? 1 : -1))])
      )
      .catch(() => {})
      .finally(() => (this.loading = false))
  },
  watch: {
    selectedUserToReplace() {
      this.occurrences = {}
      this.selectedMocs = []
      this.items = []
    },
    selectedRoles() {
      console.log(`user replace moc.vue watch selectedRoles`)
      this.occurrences = {}
      this.selectedMocs = []
      this.items = []
      this.roleSelected = this.selectedRoles && this.selectedRoles.value !== '' ? true : false
      if (this.roleSelected) this.$refs.form.resetValidation()
    },
    selectedCommunity() {
      this.occurrences = {}
      this.selectedMocs = []
      this.items = []
    }
  },
  provide() {
    return { getPeoplePickerInjectedProperties: this.getPeoplePickerInjectedProperties }
  }
}
</script>
<style scoped>
.success-alert a {
  color: white;
  font-weight: bold;
}

.content-end {
  justify-content: flex-end;
  display: flex;
}

.roles {
  word-break: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  height: 20px;
  max-width: 200px;
}

.header-checkbox {
  padding:25px 0 0 10px;
}

.v-input__icon--prepend .v-icon {
  color: red;
}
</style>
